import { Component, inject, signal, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, SidebarComponent, HeaderComponent],
  template: `
    <div class="app-layout" [class.sidebar-collapsed]="sidebarCollapsed()">
      <app-sidebar
        [collapsed]="sidebarCollapsed()"
        [isMobile]="isMobile()"
        (toggleCollapse)="toggleSidebar()"
      />
      <div class="main-area">
        <app-header
          [sidebarCollapsed]="sidebarCollapsed()"
          (toggleSidebar)="toggleSidebar()"
        />
        <main class="content-area">
          <router-outlet />
        </main>
      </div>
    </div>
    @if (isMobile() && !sidebarCollapsed()) {
      <div class="sidebar-overlay" (click)="toggleSidebar()"></div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .app-layout {
      display: flex;
      height: 100vh;
      overflow: hidden;
      background: var(--bg-primary);
    }
    .main-area {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      min-width: 0;
    }
    .content-area {
      flex: 1;
      overflow-y: auto;
      padding: 1.5rem;
      background: var(--bg-secondary);
    }
    .sidebar-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 90;
      backdrop-filter: blur(2px);
    }
    @media (max-width: 768px) {
      .content-area {
        padding: 1rem;
      }
    }
  `],
})
export class LayoutComponent {
  private readonly platformId = inject(PLATFORM_ID);
  sidebarCollapsed = signal(false);
  isMobile = signal(false);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
      window.addEventListener('resize', () => this.checkScreenSize());
    }
  }

  toggleSidebar() {
    this.sidebarCollapsed.update(v => !v);
  }

  private checkScreenSize() {
    const mobile = window.innerWidth < 768;
    this.isMobile.set(mobile);
    if (mobile) {
      this.sidebarCollapsed.set(true);
    }
  }
}
